import { Outlet } from "react-router-dom";

import useLayerLogin from "../auth/useLayerLogin";

export default function WithAuthenticationRequired<P extends object>(props: P) {
  const { isAuthenticated } = useLayerLogin();
  return isAuthenticated ? <Outlet {...props} /> : <></>;
}
